import { create } from 'zustand';

export const useMappingFormStore = create((set, get) => ({
  // Instance du formulaire Ant Design
  formInstance: null,

  // Actions
  setFormInstance: (form) => set({ formInstance: form }),

  clearFormInstance: () => set({ formInstance: null }),

  getFormInstance: () => get().formInstance,

  // Validation du formulaire
  validateForm: async () => {
    const form = get().formInstance;
    if (!form) {
      console.warn('Form instance not available');
      return { success: false, errors: [] };
    }
    try {
      await form.validateFields();
      return { success: true, errors: [] };
    } catch (errorInfo) {
      return { success: false, errors: errorInfo.errorFields || [] };
    }
  },

  // Reset des erreurs de validation
  resetFormErrors: () => {
    const form = get().formInstance;
    if (form) {
      form.resetFields();
    }
  },
}));
